const appendScript = (src, id) => {
  if (document.getElementById(id)) return;
  const script = document.createElement("script");
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

export function installOptionalTracking() {
  const hubspotPortal = process.env.REACT_APP_HUBSPOT_TRACKING_PORTAL_ID;
  if (hubspotPortal) {
    appendScript(`https://js.hs-scripts.com/${hubspotPortal}.js`, "hubspot-tracking");
  }

  const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
  if (!measurementId) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", measurementId);
  appendScript(
    `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`,
    "ga4-tag"
  );
}
